<template>
  <div class="logo p" v-if="site.logos && site.logos.length > 0">
    <template v-if="inview">
      <img
        v-for="(img, index) in site.logos"
        :key="index"
        :class="{ active: scrollIndex == index }"
        :src="img.url"
        alt=""
        :style="{ 'transform': 'translate(-50%,-50%) rotateX(' + scrollAngle + 'deg)'}"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      scrollPos: 0,
      scrollAngle: 0,
      scrollIndex: 0,
      increment: 360
    };
  },
  mounted() {
    this.$root.$on("turnoff", this.turnOff);
    this.$root.$on("turnon", this.turnOn);
  },
  created() {
    if(window.innerWidth < 768) {
      setTimeout(() => {
            window.requestAnimationFrame(this.playMobileAnimation)
      }, 1000);
    } else {
      window.addEventListener("scroll", this.changeQuestion);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.changeQuestion);
  },
  computed: {
    ...mapState(["site"]),
    inview() {
      return this.$store.state.inview;
    }
  },
  methods: {
      playMobileAnimation(time) {
            this.scrollPos += 6;
            this.mobileQuestion();
            let lastTime;
            if (lastTime != null) {
                  lastTime = time;
            }
            lastTime = time;
            window.requestAnimationFrame(this.playMobileAnimation);
      },
      turnOff() {
            this.$store.state.inview = false;
      },
      turnOn() {
            this.$store.state.inview = true;
      },
      mobileQuestion() {
            if(this.site.logos.length > 1 ) {
                  this.scrollIndex = Math.floor((this.scrollPos + 360) / (this.increment * 4));
            }
            this.scrollAngle = this.scrollPos / 4;
      },
      changeQuestion() {
            let scrollPos = window.pageYOffset;
            let scrollLength = this.increment * this.site.logos.length;
            let scrollCycles = 0;
            if (window.pageYOffset > scrollLength * 4) {
                  scrollCycles = Math.floor(window.pageYOffset / scrollLength);
                  scrollPos = scrollPos - scrollCycles * (scrollLength * 4);
            }
            if(this.site.logos.length > 1 ) {
                  this.scrollIndex = Math.floor((scrollPos + 360) / (this.increment * 4));
            }
            this.scrollAngle = scrollPos / 4;
      }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  @media only screen and (max-width:768px) {
    position: relative;
    width:100%;
    height:60vh;
  }
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    padding: calc(3 * var(--lh));
    object-fit: contain;
    display: none;
    &.active,
    &.defaultImg {
      display: block;
    }
  }
}
</style>